import React, { useEffect, useState } from 'react';
import './Locks.scss';
import { connect } from 'react-redux';
import {
  getLocksActionRequest,
  filterLocksAction,
  setLocksSortDataAction,
  sortLocksAction,
  updateQuickFilterAction
} from '../../store/lock/lockActions';
import MercurXLockTable 
from '../../components/MercurXLockTable/MercurXLockTable';
import {  Col, Dropdown, Form, Row, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
// import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
// import MercurXIcons from '../../components/MercurXIcons/MercurXIcons';
import MercurXIcons from '../../components/MercurXIcons/MercurXIcons';
import { locksQuickFilterConstants, sortKeys, sortTypes } from './locksConstants';


function Locks({ ...props }) {
  const {
    getLocksRequest,
    quickFilter,
    locksSortData,
    updateQuickFilter,
    setLocksSortData,
    sortLocks,
    filterLocks,
  } = props;

  const [filterInput, setFilterInput] = useState('');

  useEffect(() => {
    getLocksRequest();
    updateQuickFilter(locksQuickFilterConstants.ALL)
  }, []);
  useEffect(() => {
    filterLocks(filterInput);
    sortLocks();
  }, [quickFilter]);

  useEffect(() => {
    filterLocks(filterInput);
  }, [filterInput])

  function changeSortType(sortType) {
    const newLockSortData = { ...locksSortData, sortType };
    setLocksSortData(newLockSortData);
    sortLocks();
  }

  function changeSortKey(sortKey) {
    const newLockSortData = { ...locksSortData, sortKey };
    setLocksSortData(newLockSortData);
    sortLocks();
  }

  return (
    <>
      <div className="text-fs-head-md mb-4">Locks</div>
      <Row className="text-fs-body-md mt-4 text-center">
        <Col>
          <Form.Control
            className="text-fs-body-sm"
            type="text"
            placeholder="Search by token symbol, address or txn hash..."
            aria-label="text"
            aria-describedby="basic-addon1"
            value={filterInput}
            onChange={(e) => setFilterInput(e.target.value)}
            size={'sm'}
          />
        </Col>
      </Row>
      <Row
        id="locks-container"
        className="d-flex align-items-center justify-content-between mt-4"
      >
        <Col>
          <div id="locks-sorting-section" className="d-flex align-items-center py-2">
          <Dropdown className="me-2 projects-table-button">
              <Dropdown.Toggle size={'sm'} className="d-flex align-items-center">
                <MercurXIcons name="MdSort" size="18" />
                <span className="ms-1">{sortTypes[locksSortData.sortType].name}</span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="py-1">
                {sortTypes.map((sortType, index) => {
                  return (
                    <Dropdown.Item
                      key={index}
                      className="d-flex align-items-center px-1"
                      onClick={() => changeSortType(index)}
                    >
                      <MercurXIcons name={sortType.icon} size="18" />
                      <span className="ms-2">{sortType.name}</span>
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
            <Dropdown className="projects-table-button">
              <Dropdown.Toggle size={'sm'} className="d-flex align-items-center">
                <MercurXIcons name="BiFilterAlt" size="18" />
                <span className="ms-1">{sortKeys[locksSortData.sortKey].name}</span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="py-1">
                {sortKeys.map((sortKey, index) => {
                  return (
                    <Dropdown.Item
                      key={index}
                      className="d-flex align-items-center px-1"
                      onClick={() => changeSortKey(index)}
                    >
                      <span>{sortKey.name}</span>
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Col>
        <Col className="text-md-end">
        <ToggleButtonGroup size={'sm'} type="radio" name="options" defaultValue={1}>
        <ToggleButton
              size={'sm'}
              variant={quickFilter === locksQuickFilterConstants.ALL ? 'primary' : 'light'}
              className={
                quickFilter !== locksQuickFilterConstants.ALL ? 'text-t-body-color' : ''
              }
              id="tbg-radio-1"
              value={locksQuickFilterConstants.ALL}
              onClick={() => updateQuickFilter(locksQuickFilterConstants.ALL)}
            >
              All
            </ToggleButton>
            <ToggleButton
              size={'sm'}
              variant={quickFilter === locksQuickFilterConstants.LOCKED ? 'primary' : 'light'}
              className={
                quickFilter !== locksQuickFilterConstants.LOCKED ? 'text-t-body-color' : ''
              }
              id="tbg-radio-2"
              value={locksQuickFilterConstants.LOCKED}
              onClick={() => updateQuickFilter(locksQuickFilterConstants.LOCKED)}
            >
              Locked
            </ToggleButton>
            <ToggleButton
              size={'sm'}
              variant={quickFilter === locksQuickFilterConstants.CLAIM ? 'primary' : 'light'}
              className={
                quickFilter !== locksQuickFilterConstants.CLAIM ? 'text-t-body-color' : ''
              }
              id="tbg-radio-3"
              value={locksQuickFilterConstants.CLAIM}
              onClick={() => updateQuickFilter(locksQuickFilterConstants.CLAIM)}
            >
              Claim
            </ToggleButton>
            <ToggleButton
              size={'sm'}
              variant={quickFilter === locksQuickFilterConstants.DONE ? 'primary' : 'light'}
              className={
                quickFilter !== locksQuickFilterConstants.DONE ? 'text-t-body-color' : ''
              }
              id="tbg-radio-4"
              value={locksQuickFilterConstants.DONE}
              onClick={() => updateQuickFilter(locksQuickFilterConstants.DONE)}
            >
              Done
            </ToggleButton>
          </ToggleButtonGroup>
        </Col>
      </Row>
      <div id="locks-container">
        <MercurXLockTable />
      </div>
      
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    quickFilter: state.lockReducer.quickFilter,
    locksSortData: state.lockReducer.locksSortData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getLocksRequest: (payload) => {
      dispatch(getLocksActionRequest(payload));
    },
    updateQuickFilter: (payload) => {
      dispatch(updateQuickFilterAction(payload));
    },
    setLocksSortData: (payload) => {
      dispatch(setLocksSortDataAction(payload));
    },
    sortLocks: (payload) => {
      dispatch(sortLocksAction(payload));
    },
    filterLocks: (payload) => {
      dispatch(filterLocksAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Locks);
